import { render, staticRenderFns } from "./Base_Type4.vue?vue&type=template&id=b83573d4&scoped=true"
import script from "./Base_Type4.vue?vue&type=script&lang=js"
export * from "./Base_Type4.vue?vue&type=script&lang=js"
import style0 from "./Base_Type4.vue?vue&type=style&index=0&id=b83573d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83573d4",
  null
  
)

export default component.exports